import React from 'react';
import { Select } from '@coolremote/shared';
import clsx from 'clsx';
import useStyles from './styles';
import { t } from 'ttag';

const ListControl = ({ mode, value, onChange, options, isDisabled, textSize, selectClassName }) => {
  const classes = useStyles({textSize});

  if (mode === 'edit') {
    return (
      <div style={{fontSize:textSize || 'inherit'}} className={classes.root}>
        {t`Auto`}
        <div className={classes.downArrowStyle}></div>
      </div>
    );
  }

  return (
    <div>
      <Select
        disabled={isDisabled}
        value={value}
        fullWidth
        className={clsx(classes.customSelectField, selectClassName)}
        onChange={onChange}
        options={options}
        menuPortal
      />
    </div>
  );
};

export default ListControl;
